import styled from 'styled-components';

export const VideoTutorialsWrapper = styled.div`
.entry-title {
    font-weight: 600;
    font-size: 1.8rem;
}
figure>img {
    max-width: unset;
    vertical-align: middle;
    width: 100%;
    height: auto;
}
figure{
    aspect-ratio: 16 / 9;
    grid-area: media-text-media;
    margin: 0;
    position: relative;
}
.has-shadow {
    box-shadow: 0 1.5vw 3vw -.7vw rgb(0 0 0 / .125);
}
img:is([sizes=auto i],[sizes^="auto," i]) {
    contain-intrinsic-size: 3000px 1500px;
}
.source-code{
    align-items: center;
    display: grid;
    grid-template-areas: "media-text-content media-text-media";
    grid-template-columns: auto 55%;
    grid-template-rows: auto;
    margin-left: auto;
    margin-right: auto;
    padding: 0 !important;
    position: relative;
}
.has-huge-padding{
    padding: 2em;
}
.source-code-inner{
    position: relative;
    overflow-wrap: break-word;
    height: 100%;
    margin-bottom: 32px;
    min-width: 0;
    word-break: break-word;
}
.has-medium-gutter{
    margin-right: 1em;
}
.epyt-gallery-subscribe a.epyt-gallery-subbutton, .epyt-gallery-subscribe a.epyt-gallery-subbutton:hover {
    background-color: #e62117 !important;
    border-radius: 3px;
    color: #fff !important;
    display: inline-block;
    padding: 5px 10px;
    text-decoration: none !important;
}
.epyt-gallery-subscribe {
    clear: both;
    padding: 15px 0 10px;
    text-align: center;
}
.epyt-gallery-subscribe a.epyt-gallery-subbutton img {
    background: transparent;
    box-shadow: none;
    display: inline-block;
    height: auto !important;
    margin: 0;
    padding: 0 6px 3px 0;
    vertical-align: middle !important;
    width: 20px !important;
}
.source-code-div{
    margin-right: -100px;
    margin:left:0;
    z-index:1;
}
`;
